document.addEventListener('DOMContentLoaded', (event) => {
  const wrapper = document.querySelector('.wp-block-freightos-big-info-circles');
  if (!wrapper) return;
  const items = wrapper.querySelectorAll('.button-info-circle');

  [...items].forEach(((item) => {
    item.addEventListener('click', () => {
      item.classList.toggle('active');
    });
  }));
});
